module.exports = __webpack_public_path__ + "static/img/9areaA_04.58e24f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/9areaA_04.png
// module id = 1068
// module chunks = 1